export const policiesTableConf = [
  {
    field: 'policies',
    title: 'Policies'
  },
  {
    field: 'applications',
    title: 'Applications'
  },
  {
    field: 'icon',
    title: ''
  }
];
